import { render } from "./SimpleInput.vue?vue&type=template&id=a4b2da6a&ts=true&lang=pug"
import script from "./SimpleInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleInput.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__